import { cn, DashboardGrid, useDashboardWidgets } from '@xhubio-saas/core-frontend/kernel'
import { useTranslation } from 'react-i18next'

/**
 * Dashboard page
 *
 * Page header = heading + ONE sentence saying what the page shows (replaced
 * the former "Welcome, <name>!", which said nothing about the content).
 *
 * `dashboard-calm` scopes the calm look (one-hue charts, frameless widgets on
 * the tinted canvas) to this page — see the matching block in `index.css`.
 */
export function DashboardPage() {
  const { t } = useTranslation()
  const { widgets } = useDashboardWidgets()

  return (
    <div className={cn('dashboard-calm container mx-auto space-y-6 px-4 py-8')}>
      <div className="space-y-1">
        <h1 className="text-3xl tracking-tight">{t('dashboard.title', 'Übersicht')}</h1>
        <p className="text-sm text-muted-foreground">
          {t(
            'dashboard.description',
            'API-Nutzung und Systemaktivität der Organisation im gewählten Zeitraum.'
          )}
        </p>
      </div>

      {/* Dashboard widgets */}
      <DashboardGrid />

      {/* Empty state if no widgets */}
      {widgets.length === 0 && (
        <div className="rounded-lg bg-card p-8 text-center">
          <h3 className="mb-2 text-lg font-medium">
            {t('dashboard.emptyTitle', 'No widgets yet')}
          </h3>
          <p className="text-muted-foreground">
            {t('dashboard.emptyDescription', 'Your dashboard widgets will appear here.')}
          </p>
        </div>
      )}
    </div>
  )
}
